// #region Imported Files 

/* eslint-disable default-case */
import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { connect, useDispatch, useSelector } from 'react-redux';
//import linkedinIcon from '@iconify-icons/uil/linkedin';
//import youtubeIcon from '@iconify-icons/mdi/youtube';
//import Logo from '../../assets/images/authenteklogo.png';
import '../../../src/custom.css'
import LoginImage from "../../assets/images/login-image.png";
//import Signinsqurelight from "../../assets/images/logout.png";
import { useHistory } from "react-router-dom";
import Changepassword from "../../assets/images/change-password.png";
import BackArrow from "../../assets/images/arrow-back.svg";
import DropArrow from "../../assets/images/drop-arrow.png";
import DropArrowBlack from "../../assets/images/droparrow-black.png";
import { Link, NavLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { loginasuser, fetchUsersFromNotification } from "../../Redux/Api/fetch.api";
import { validateuserdata, getuserslistfromnotification } from '../../Redux/Actions/UsersActions';
import Loader from "../loader";
import * as signalR from "@microsoft/signalr";
import { fetchLogout, getApprovedVersionSummariesList, getVersionSummaryApprovalCount } from "../../Redux/Api/fetch.api";
import { Modal, Button } from "react-bootstrap";
import { Form } from "reactstrap"
import TEKaVerseSiteMap from "../../assets/images/SiteMap.png";
//import SiteMapIcon from "../../assets/images/SiteMap.svg";
import MapIcon from "../../assets/images/map-icon.png";
import { Tooltip, Skeleton, Badge } from 'antd';
import Person2Icon from '@mui/icons-material/Person2';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationIco from "../../assets/images/notifications-ico.svg";
import LanguageSwitcher from '../../LanguageSwitcher/languageSwitcher';
import { useTranslation } from "react-i18next";
import TwilloMissedCallNotification from '../TwilloMissedCallNotification';
import HandymanIcon from '@mui/icons-material/Handyman';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import PlayArrowIcon from '@mui/icons-material/LaptopMac';// for Active
import NewReleasesIcon from '@mui/icons-material/NewReleases'; // for New
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // for Resolved
import ReplayIcon from '@mui/icons-material/Replay'; // for ReOpen
import BugReportIcon from '@mui/icons-material/BugReport'; // for QA
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'; // for Deployed
import BuildIcon from '@mui/icons-material/Build'; // for Build Version
import WebhookIcon from '@mui/icons-material/Webhook';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
// add icon for build version only
// #endregion

const Navbar = ({ supportRequestCount, language, isSupportCall }) => {

    // #region Global variables
    const { t } = useTranslation('header');
    const [loading, setLoading] = useState(false);
    const allLoginTypes = useSelector((state) => state.allLogindata.login);
    const allUserTypes = useSelector((state) => state.allUserdata.users);
    const userCompany = allUserTypes.data && allUserTypes.data.userCompanyDetails;
    const companyLogo = userCompany && userCompany[0].companyLogo;
    const colorcode = allUserTypes.data && allUserTypes.data.colorCodeDetails;
    const headercolor = colorcode && colorcode.headerColorCode;
    const userRole = allUserTypes.data && allUserTypes.data.userRoleDetails;
    const roleName = userRole && userRole[0].roleName;
    const roleId = userRole && userRole[0].roleId;
    const emailid = userRole && userRole[0].emailId;
    const firstname = userRole && userRole[0].firstName;
    const lastname = userRole && userRole[0].lastName;
    const username = `${firstname ?? ""} ${lastname ?? ""}`.trim();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [settingdropdownOpen, setSettingDropdownOpen] = useState(false);
    const [supportdropdownOpen, setSupportDropdownOpen] = useState(false);
    const logincheck = localStorage.getItem('isloginClicked');
    const remmeberMe = localStorage.getItem('isChecked');
    const loggedInEmailId = localStorage.getItem('emailid');
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const apps = ["/Apps"];
    const [showModal, setShowModal] = useState(false);
    const openModal = () => setShowModal(true);
    const [isSiteMapOpened, setisSiteMapOpened] = useState(false);
    const [allUserData, setAllUserData] = useState([]);
    const loggedUserId = localStorage.getItem('UserId')
    const userId = allUserTypes.data && allUserTypes.data.userId;
    const profilePicture = userRole && userRole[0].profilePicture;
    //  const profilePicture = localStorage.getItem('profilePicture');
    const [notificationCount, setNotificationCount] = useState(1);
    const { REACT_APP_JOBS_LINK } = process.env;
    const [showNotifications, setShowNotifications] = useState(false);
    const [notificationsData, setNotificationsData] = useState([]);
    const [versionApprovalList, setVersionApprovalList] = useState([]);
    const companyId = allUserTypes.data && allUserTypes.data.userRoleDetails[0].companyId;
    // #endregion

    // #region useEffect / Hooks
    useEffect(() => {
        if (localStorage.getItem('tekaVerseToken') == null) {
            history.push("/");
        }

        const connection = new signalR.HubConnectionBuilder()
            .withUrl("/logoutHub")
            .build();

        connection.start().then().catch((err) => console.error(err));

        connection.on("ShowAlert", (emailId, isRefresh) => {
            if (emailId == loggedInEmailId) {
                if (!isRefresh) {
                    if (!remmeberMe) {
                        localStorage.removeItem('userName')
                        localStorage.removeItem('emailid')
                        localStorage.removeItem('password')
                        localStorage.removeItem('isChecked')
                        localStorage.removeItem('tekaVerseToken');
                    }
                    localStorage.removeItem('tekaVerseToken');
                    openModal()
                } else {
                    window.location.reload(true);
                }
            }
        });

        getallusersdata();
        getApprovedVersionSummaries(userId, companyId);
        if (loggedUserId != null && loggedUserId != undefined && loggedUserId == 3) {
            getVersionSummaryApproval();
        }

        return () => {
            connection.off("ShowAlert");
        };
    }, [])
    // #endregion

    // #region Events
    const MyProfile = () => {
        history.push('/MyProfile')
    }

    const handleKey = (event) => {
        if (event.keyCode === 1) {
            switch (event.target.innerText) {
                case 'Apps':
                    return history.push("/Apps");
                case 'Company':
                    return history.push("/Company")
                case 'User':
                    return history.push("/User")
            }
        }
    }

    const ChangePassword = (e) => {
        history.push('/ChangePassword');
    };

    const BackToAccount = () => {
        localStorage.removeItem('tekaVerseToken');
        localStorage.removeItem('loginAsUser');
        getvalidateuser();
    }

    const getvalidateuser = () => {
        loginasuser(loggedInEmailId)
            .then(response => {
                dispatch(validateuserdata(response.data))
                localStorage.setItem('UserId', response.data.data.userId);
                localStorage.setItem('tekaVerseToken', response.data.data.token);
                localStorage.setItem('isloginClicked', false)

                history.push("/Dashboard");
                window.location.reload(true);

            })
            .catch((err) => {
                console.log("Err: ", err);
            });

    }

    const getallusersdata = () => {
        setLoading(true)
        fetchUsersFromNotification()
            .then(response => {
                dispatch(getuserslistfromnotification(response.data))
                setAllUserData(response.data.data)
                setLoading(false)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const supportUser = allUserData && allUserData.includes(parseInt(loggedUserId));

    const logoutUser = () => {
        //IsLogoutOrRefresh = true -- Refresh
        //IsLogoutOrRefresh = false -- Logout

        fetchLogout(loggedInEmailId, false, true)
            .then(response => {
            })

            .catch((err) => {
                console.log("Err: ", err);
            });

    }

    const handleToggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const handleSettingDropdown = () => {
        setSettingDropdownOpen(!settingdropdownOpen);
    };

    const handleSupportDropdown = () => {
        setSupportDropdownOpen(!supportdropdownOpen);
    };

    const Logout = (e) => {
        logoutUser();
        if (!remmeberMe) {
            localStorage.removeItem('userName')
            localStorage.removeItem('loginAsUser')
            localStorage.removeItem('emailid')
            localStorage.removeItem('password')
            localStorage.removeItem('isChecked')
            localStorage.removeItem('tekaVerseToken');
            localStorage.removeItem('profilePicture');
            localStorage.removeItem('UserId');
            window.location.reload(true);
        }
        localStorage.removeItem('tekaVerseToken');
        localStorage.removeItem('UserId');
        window.location.replace("/");
    };

    const handleCloseSiteMap = () => {
        setisSiteMapOpened(false);
    }

    const handleOpenSiteMap = () => {
        setisSiteMapOpened(true);
    };

    const handleMouseEnter = () => {
        setSettingDropdownOpen(true);

    };

    const handleMouseLeave = () => {
        setSettingDropdownOpen(false);
    };

    const handleMappingMouseEnter = () => {
        setDropdownOpen(true);
    };

    const handleMappingMouseLeave = () => {
        setDropdownOpen(false);
    };

    const handleSupportMouseEnter = () => {
        setSupportDropdownOpen(true);
    };

    const handleSupportMouseLeave = () => {
        setSupportDropdownOpen(false);
    };

    const handleClick = () => {
        setSettingDropdownOpen(prev => !prev);
    };

    const openJobs = () => {
        //var url = "https://tekaverse.com/Jobs/Dashboard"
        //var win = window.open(url, '_blank');
        var win = window.open("/Jobs/Dashboard", '_blank');
        win.focus();
    }

    const openSubscription = () => {
        var win = window.open("/Support/Subscription", '_blank');
        win.focus();
    }

    const openFeedBack = () => {
        history.push("/Workitem");
    }

    const openNotification = () => {
        // window.location.href = "/Version";
        history.push("/Version");
    }

    const openTEKaPickApp = () => {
        history.push("/TEKaPickApp");
    }

    // #endregion
    const toggleNotifications = () => {
        setShowNotifications((prev) => !prev);
    };

    const getApprovedVersionSummaries = async (userId, pageIndex = 1, pageSize = 50) => {
        try {
            setLoading(true);
            const response = await getApprovedVersionSummariesList(userId, pageIndex = 1, pageSize = 50);
            console.log("API Response:", response?.data?.data);

            // Ensure response structure is correct
            setNotificationsData(response?.data?.data || []);
        } catch (err) {
            console.error("Error:", err);
        } finally {
            setLoading(false);
        }
    };
    const getVersionSummaryApproval = async () => {
        try {
            setLoading(true);
            const response = await getVersionSummaryApprovalCount();
            console.log("API Response:", response?.data?.data);

            // Ensure response structure is correct
            setVersionApprovalList(response?.data?.data || []);
        } catch (err) {
            console.error("Error:", err);
        } finally {
            setLoading(false);
        }
    };
    const handleMouseEnterOnVersions = () => {
        setShowNotifications(true); // Show when hovering on icon or list
    };

    const openVersions = () => {
        history.push("/Version");
    }

    const handleMouseLeaveOnVersions = () => {
        setShowNotifications(false); // Hide when mouse leaves both icon and list
    };
    // Call API on component mount
    // useEffect(() => {
    //     getApprovedVersionSummaries();
    // }, []);
    const getFullDate = (date) => {
        if (!date) return ""; // Return empty string if date is null or undefined
        const newDate = new Date(date);
        const returnDate = ((newDate.getMonth() > 8) ? (newDate.getMonth() + 1) : ('0' + (newDate.getMonth() + 1))) + '-' + ((newDate.getDate() > 9) ? newDate.getDate() : ('0' + newDate.getDate())) + '-' + newDate.getFullYear();
        const dateAndTime = date.split("T");
        const time = dateAndTime[1].split(":");
        const seconds = parseInt(time[2]);
        const newtime = time[0] + ":" + time[1] + ":" + seconds;
        const times = time[0] > 12 ? time[0] % 12 : time[0];
        const timeslatest = times < 9 ? ('0' + times) : times;
        const newtime1 = timeslatest + ":" + time[1] + ":" + seconds;
        if (time[0] && time[0] >= 12) {
            return (
                //dateAndTime[0].split("-").reverse().join("-") + ", " + newtime1 + " PM "
                returnDate + ", " + newtime1 + " PM "
                //returnDate
            );
        } else {
            return (
                //dateAndTime[0].split("-").reverse().join("-") + ", " + newtime + " AM "
                returnDate + ", " + newtime + " AM "
                //returnDate
            );
        }
    };
    return (
        <div>
            {showModal && (
                <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" style={{ color: '#000' }}>{t("LogoutConfirmation")}</h5>
                            </div>
                            <div className="modal-body" style={{ color: '#000' }}>
                                <p>{t("YouhavebeenloggedoutbytheSuperAdmin")}</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={Logout}>{t("Ok")}</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModal && <div className="modal-backdrop fade show"></div>}
            <div className="top_bar_outer" style={{
                backgroundColor: headercolor,
            }}
            >
                <div className="container-fluid">
                    <div className="top_bar">
                        <ul className="top_contact_detail">
                            <li className="list-inline-item list-unstyled" style={{ cursor: "pointer" }}>
                                <div className="feedback-btn d-flex">
                                    <button className="feedback-button" onClick={(e) => openFeedBack()}>
                                        <HistoryEduIcon className="mr-2" style={{ color: "#fff" }}/>
                                        <span>{t("Feedback")}</span>
                                    </button>
                                </div>
                            </li>

                            <div className="list-inline-item list-unstyled"
                                style={{ cursor: "pointer" }}
                                onMouseEnter={handleMouseEnterOnVersions}
                                onMouseLeave={handleMouseLeaveOnVersions}
                            >
                                {notificationsData.length > 0 && (


                                    <div className="bg-light px-2 rounded py-1 d-inline-block position-relative" >
                                        <Badge offset={[5, 5]} size="small">
                                            <span className="d-inline-block mx-1">
                                                <HandymanIcon />
                                            </span>
                                        </Badge>
                                        <span className="notification-count">{notificationsData.length}</span>
                                    </div>
                                )}
                                {/* Notification List */}
                                {showNotifications && (
                                    <div
                                        className="list-inline-item notification-wrapper"
                                        onMouseEnter={handleMouseEnterOnVersions}
                                        onMouseLeave={handleMouseLeaveOnVersions} // Prevent closing when hovering
                                    // Hide when mouse leaves
                                    >
                                        <div className="notification-list">
                                            <div className="notification-header">
                                                <h4>Version Summaries</h4>
                                            </div>

                                            <ul className="notification-item">
                                                {notificationsData.map((notification, index) => (
                                                    <li>
                                                        <span className={`status-icon ${notification.status === 0 ? "status-new" :
                                                            notification.status === 1 ? "status-active" :
                                                                notification.status === 2 ? "status-resolved" :
                                                                    notification.status === 3 ? "status-reopen" :
                                                                        notification.status === 4 ? "status-qa" :
                                                                            notification.status === 5 ? "status-deployed" : ""
                                                            }`}>

                                                            {notification.status === 0 && <NewReleasesIcon />}
                                                            {notification.status === 1 && <PlayArrowIcon />}
                                                            {notification.status === 2 && <CheckCircleIcon />}
                                                            {notification.status === 3 && <ReplayIcon />}
                                                            {notification.status === 4 && <BugReportIcon />}
                                                            {notification.status === 5 && <RocketLaunchIcon />}
                                                        </span>

                                                        <div className='flex-box'>
                                                            <div className='d-flex gap-0 justify-content-between'>
                                                                <strong>{`[WI : ${notification.workItemID}]`} </strong>
                                                                <small>{getFullDate(notification.updatedDate)}</small>
                                                            </div>
                                                            <small>{notification.versionSummary.replace(/&nbsp;/g, '')}</small>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            {/* </div> */}

                                            <div className="notification-footer" onClick={openNotification}>
                                                See All Version Updates
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>

                        </ul>

                        <ul className="top_social list-inline">
                            <div className="list-inline-item list-unstyled m-0"
                                style={{ cursor: "pointer" }}>

                                {versionApprovalList > 0 && (
                                    <div className="bg-light px-2 rounded py-1 d-inline-block position-relative" >
                                        <span className="d-inline-block version-tooltip-wrapper" onClick={(e) => openVersions()}>
                                            <WebhookIcon style={{ color: "#000" }} />
                                            <span className="version-tooltip">
                                                It looks like some new builds have arrived<br />and are waiting for your <b style={{ color: "green" }}>approval</b>.
                                            </span>
                                        </span>

                                        <span className="notification-approval-count">{versionApprovalList}</span>
                                    </div>
                                )}
                            </div>

                            <TwilloMissedCallNotification />

                            <li className="list-inline-item">
                                <LanguageSwitcher language={language} />
                            </li>

                            <li className="list-inline-item">
                                <div className="dropdown header-dropdown">
                                    <button className="d-flex dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">

                                        <div className="card d-flex align-items-center whflex dropdown-toggle p-0">
                                            {/*<span> <img src={LoginImage}></img></span>*/}
                                            <div className="content m-0">
                                                <h6 className="dashboard_user d-flex align-items-center gap-2">
                                                    <div className='img-height' ><img src={profilePicture != null && profilePicture != "null" && profilePicture !== "" ? profilePicture : LoginImage}></img></div>
                                                    <div className="hide-mobile">
                                                        <h6 className="m-0">{username} </h6>
                                                    </div>
                                                </h6>
                                            </div>
                                        </div>
                                    </button>
                                    <ul className="dropdown-menu side_profile" aria-labelledby="dropdownMenuButton1">
                                        <div className="card d-flex align-items-center">
                                            <span>
                                                <div className="profile-pic-size"><img src={profilePicture != null && profilePicture != "null" && profilePicture !== "" ? profilePicture : LoginImage}></img></div>
                                            </span>
                                            <div className="content">
                                                <h5>{username} {"(" + roleName + ") "}</h5>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <p className="text-muted" style={{ margin: 0 }}>{emailid}</p>

                                                    {isSupportCall ?
                                                        <Tooltip title="You are also a Support Technician">
                                                            <img
                                                                className="tech-pic-size"
                                                                src="https://authentekstorage.blob.core.windows.net/tekaverse-dev-container/engineer.png"
                                                                alt="Profile"
                                                            />
                                                        </Tooltip>
                                                        : ""}
                                                </div>
                                            </div>
                                        </div>

                                        <ul>
                                            {logincheck == "true" ?
                                                <li className="remove_dots">  <a className="dropdown-item" onClick={(e) => BackToAccount(e)}>
                                                    <img src={BackArrow}></img>
                                                    {t("BackToMyAccount")}</a>
                                                </li> : ""
                                            }

                                            <li className="remove_dots">  <a className="dropdown-item" onClick={(e) => ChangePassword(e)}>
                                                <img src={Changepassword}></img>
                                                {t("ChangePassword")}</a>
                                            </li>

                                            <li className="remove_dots">  <a className="dropdown-item" onClick={(e) => MyProfile()}>
                                                <Person2Icon className='mr-2' fontSize="small" />
                                                {t("MyProfile")}</a>
                                            </li>

                                            <li className="remove_dots"><a className="dropdown-item" onClick={(e) => Logout(e)}>
                                                <LogoutIcon className='mr-2' fontSize="small" />
                                                {t("SignOut")}</a>
                                            </li>
                                        </ul>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {loading ? <Skeleton active /> :
                <>
                    {userId != 2
                        ?
                        <Link className="navbar-brand main_logo" to="/Apps"> <img src={companyLogo} alt="Logo" /> </Link>
                        :
                        <nav className="navbar navbar-expand-lg navbar-light">
                            <div className="container-fluid">

                                <div className="mob-header-ui">
                                    <Link className="navbar-brand main_logo" to="/Apps">
                                        <img src={companyLogo} alt="Logo" />
                                    </Link>

                                    {/*<Link className="navbar-brand main_logo" to="/Apps">*/}
                                    {/*    <img src={companyLogo} alt="Logo" />*/}
                                    {/*</Link>*/}

                                    {/*<div className="d-flex ms-auto">*/}
                                    {/*    <button className="subscription-button" onClick={(e) => openSubscription(e)}>*/}
                                    {/*        Subscription*/}
                                    {/*    </button>*/}
                                    {/*</div>*/}
                                </div>

                            </div>
                        </nav>}

                    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                        <div className="container-fluid">

                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>

                            <div className="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">

                                {userRole && userRole.map((item, id) =>
                                    <ul className="navbar-nav  mb-2 mb-lg-0" >

                                        {item.roleId >= 1 ?
                                            <>
                                                <li className="nav-item" tabIndex={1} onKeyDown={(event) => handleKey(event)}>
                                                    <NavLink className="nav-link" to="/Dashboard" exact activeClassName="active">{t("Dashboard")}</NavLink>
                                                </li>
                                            </>
                                            : ""}

                                        {item.roleId >= 7 && item.roleId != 9 ?
                                            <>
                                                <li className="nav-item" tabIndex={2} onKeyDown={(event) => handleKey(event)}>
                                                    <NavLink className="nav-link" to="/Company" activeClassName="active">{t("Company")}</NavLink>
                                                </li>
                                                <li className="nav-item" tabIndex={4} onKeyDown={(event) => handleKey(event)}>
                                                    <NavLink className="nav-link" to="/Site" activeClassName="active">{t("Sites")}</NavLink>
                                                </li>

                                                <li className="nav-item" tabIndex={5} onMouseEnter={handleMappingMouseEnter}
                                                    onMouseLeave={handleMappingMouseLeave}
                                                    onKeyDown={(event) => handleKey(event)}>
                                                    <p className="nav-link drop-btn mb-0" activeClassName="active">
                                                        <span>{t("Mapping")}</span>
                                                        <span> <img src={DropArrow} onClick={handleToggleDropdown} ></img></span>
                                                    </p>
                                                    {dropdownOpen && (
                                                        <div className="drop-box p-0">
                                                            <NavLink className="mb-0 p-2" to="/Mapping" >{t("CompanySubCompany")}</NavLink>
                                                            <NavLink className="mb-0 p-2 border-0" to="/SubCompanyMapping">{t("SubCompanySites")}</NavLink>
                                                        </div>
                                                    )}
                                                </li>


                                            </>
                                            : ""}

                                        {item.roleId >= 6 && item.roleId != 9 ?
                                            <>
                                                <li className="nav-item" tabIndex={3} onKeyDown={(event) => handleKey(event)}>
                                                    <NavLink className="nav-link" to="/User" activeClassName="active">{t("User")}</NavLink>
                                                </li>
                                                <li className="nav-item" tabIndex={6} onKeyDown={(event) => handleKey(event)}>
                                                    <NavLink className="nav-link" to="/UserCompany" activeClassName="active">{t("UserCompany")}</NavLink>
                                                </li>
                                                <li className="nav-item" tabIndex={7} onKeyDown={(event) => handleKey(event)}>
                                                    <NavLink className="nav-link" to="/UserSite" activeClassName="active">{t("Usersite")}</NavLink>
                                                </li>

                                                <li className="nav-item" tabIndex={5} onMouseEnter={handleMouseEnter}
                                                    onMouseLeave={handleMouseLeave} onKeyDown={(event) => handleKey(event)}>
                                                    <p className="nav-link drop-btn mb-0" activeClassName="active">
                                                        <span>{t("Settings")}</span>
                                                        <span> <img src={DropArrow} onClick={handleSettingDropdown}></img></span>
                                                    </p>
                                                    {settingdropdownOpen && (
                                                        <div className="drop-box setting-dropdown">

                                                            <NavLink className="" to="/CallOrder" >{t("SupportGroup")}</NavLink>
                                                            {item.roleId >= 7 ?
                                                                <>

                                                                    <NavLink className="" to="/Banner" >{t("Banners")}</NavLink>
                                                                    <a type="text" className="logs-menu position-relative text-black mb-0">
                                                                        <p className="logs-drop d-flex justify-content-between mb-0">
                                                                            <span>{t("Logs")}</span>
                                                                            <span> <img src={DropArrowBlack}></img></span>
                                                                        </p>
                                                                        <div className="logs-submenu">
                                                                            <NavLink className="px-2 py-1" to="/UserLogs" >{t("Activity")}</NavLink>
                                                                            <NavLink className="px-2 py-1 border-0" to="/UserSessions" >{t("Sessions")}</NavLink>
                                                                        </div>
                                                                    </a>
                                                                    <NavLink className="" to="/Notifications" >{t("Notifications")}</NavLink>
                                                                    <NavLink className="" to="/Projects" >{t("Projects")}</NavLink>
                                                                    <NavLink className="border-0" to="/Tekacontroller" >{t("TEKaController")}</NavLink>
                                                                    <NavLink className="" to="/Version" >{t("Versions")}</NavLink>
                                                                </> : ""}

                                                        </div>
                                                    )}
                                                </li>
                                            </>
                                            : ""}

                                        {item.roleId >= 1 ?
                                            <>
                                                <li className="nav-item" tabIndex={1}

                                                    onKeyDown={(event) => handleKey(event)}>
                                                    <NavLink className="nav-link" to="/Apps" exact activeClassName="active">{t("Apps")}</NavLink>
                                                </li>

                                                {item.roleId >= 6 && item.roleId != 9 || item.roleId == 2 || supportUser ?
                                                    <li className="nav-item" tabIndex={5} onMouseEnter={handleSupportMouseEnter}
                                                        onMouseLeave={handleSupportMouseLeave}
                                                        onKeyDown={(event) => handleKey(event)}>
                                                        <p className="nav-link drop-btn mb-0" activeClassName="active">
                                                            <span>{t("Support")}</span>
                                                            {supportRequestCount > 0 ? <span className="blink support-badge ml-1">{supportRequestCount}
                                                            </span> : ""}
                                                            <span> <img src={DropArrow} onClick={handleSupportDropdown}></img></span>
                                                        </p>

                                                        {supportdropdownOpen && (
                                                            <div className="drop-box setting-dropdown">
                                                                {item.roleId >= 7 && item.roleId != 9 || supportUser ?
                                                                    <NavLink className="" to="/Support" >{t("Request")}</NavLink>
                                                                    : ""}

                                                                {item.roleId >= 7 && item.roleId != 9 ?
                                                                    <NavLink className="" to="/SupportReport" >{t("Report")}</NavLink>
                                                                    : ""
                                                                }

                                                                <NavLink className="" to="/users/supports" >{t("Support Logs")}</NavLink>
                                                            </div>
                                                        )}
                                                    </li> : ""
                                                }

                                                {item.roleId >= 7 && item.roleId !== 9 ? (
                                                    <>
                                                        <li className={`nav-item ${location.pathname === '/Support' ? 'active' : ''}`} >
                                                            <div
                                                                className="nav-link position-relative" // Use div instead of Link
                                                                onClick={() => openJobs()}
                                                                style={{ cursor: 'pointer' }} // Optional: Make it look like a clickable element
                                                            >
                                                                <span>{t("Jobs")}</span>
                                                            </div>
                                                        </li>
                                                    </>
                                                ) : ""}

                                                {loggedUserId == 3 ? (
                                                    <>
                                                        <li className="nav-item position-relative" title="Click to download TickPick mobile app"
                                                            onKeyDown={(event) => handleKey(event)}>
                                                            <span className="nav-link cursor-pointer" onClick={openTEKaPickApp}><PhoneIphoneIcon />TEKaPick</span>
                                                        </li>
                                                    </>
                                                ) : ""}

                                            </>
                                            : ""}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </nav>

                    <Modal
                        show={isSiteMapOpened}
                        backdrop="static"
                        keyboard={false}
                        dialogClassName="sitemap-modal-dialog-video"
                    >
                        <Modal.Header closeButton><h4 className="text-black">TEKaVerse Site Map</h4>
                        </Modal.Header>
                        <Modal.Body>
                            {
                                <Form className="form-horizontal">
                                    <div className="add-banner-body mb-3">
                                        <img className="mr-2" src={TEKaVerseSiteMap}></img>
                                    </div>
                                    <div className="text-right">
                                        <button className="btn btn-primary" type="button" onClick={handleCloseSiteMap}>
                                            Cancel
                                        </button>
                                    </div>
                                </Form>
                            }
                        </Modal.Body>

                    </Modal>
                </>
            }
        </div>
    );
};

export default Navbar;